
/*
Hacky temporary object to pass data from the SPP (not angularized) into the
planting form (angularized), since there isn't really any nice way of doing it.
Once the SPP is angularized, it might be possible to replace this with an
injectable service that stores the data.
 */

(function() {
  exports.PlantingOptions = (function() {
    function PlantingOptions(options) {
      if (options == null) {
        options = {};
      }
      this.company_id = options.company_id;
      this.crop_id = options.crop_id;
      this.spp_id = options.spp_id;
      this.fsr_id = options.fsr_id;
      this.survey_result_id = options.survey_result_id;
      this.sppPlantingPlan = options.sppPlantingPlan;
      this.sppPlanterSubscription = options.sppPlanterSubscription;
      this.sppProductSubscription = options.sppProductSubscription;
      this.calculate_population = options.calculate_population;
      this.sppPopulationAdjustment = options.sppPopulationAdjustment;
      this.min_max_pop = options.min_max_pop;
      this.events = options.events;
    }

    return PlantingOptions;

  })();

}).call(this);
